import { ReactComponent as CrownGB } from '@assets/icons/GB_Icon.svg';
import { InlineFlex } from '@components/Layout/Blocks';
import Typography from '@material-ui/core/Typography';
import { Absolute } from '@packages/layout/lib/Blocks';
import { AbsoluteProps } from '@packages/layout/lib/Blocks/Absolute';
import { createMemo } from '@packages/react';
import React from 'react';
import styled from 'styled-components';

interface CustomizableWheelProps extends AbsoluteProps {
    showText?: string;
}

export const CustomizableWheel = styled(
    createMemo<CustomizableWheelProps>(
        ({ showText, ...rest }) => (
            <Absolute component={InlineFlex} t={8} l={8} align={'center'} justify={'start'} {...rest}>
                <CrownGB className={'icon'} />
                {showText ? (
                    <Typography style={{ marginLeft: 6 }} variant={'caption'}>
                        {showText}
                    </Typography>
                ) : null}
            </Absolute>
        ),
        {
            displayName: 'CustomizableWheel',
        },
    ),
)`
    && {
        background-color: rgba(255, 255, 255, 0.7);
        padding: ${({ showText }) => `2px ${showText ? 12 : 4}px 2px 4px`};
        border-radius: 15px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        font-weight: 500;
        font-size: 10px;
        z-index: 5;

        .icon {
            height: 18px;
        }
    }
`;

CustomizableWheel.defaultProps = {
    showText: 'Customizable',
};
